import get from 'lodash/get';

import { handleAge } from './handleDOB';
import { convertGenderList } from './converters/convertListWithLocalization';
import { convertDateToUIFormat } from './converters/dateConverters';

export default (profile, genderTypesList, formatMessage) => {
  const gender = get(profile, 'gender');
  const convertedGender =
    genderTypesList && genderTypesList.find(({ value }) => value === gender);
  const dob = get(profile, 'dob');
  const dobAPIFormat = convertDateToUIFormat(dob, formatMessage);
  const ageString = dob && handleAge(dobAPIFormat, formatMessage);

  let genderString = null;

  if (gender) {
    const genderTranslated = convertGenderList(
      [convertedGender],
      formatMessage,
    );
    genderString = get(genderTranslated, '[0].label');
  }

  if (genderString && ageString) {
    return `${genderString}, ${ageString}`;
  }

  return genderString || ageString || '';
};



// WEBPACK FOOTER //
// ./src/utils/getUserDescription.js